import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  OUTREACH_LIST,
  OUTREACH_DETAILS,
  ADD_OUTREACH,
  UPDATE_OUTREACH,
  DELETE_OUTREACH,
} from "../actions/outreach.actions.types";

const call = Effects.call;

function* getOutreachList({ payload: { data, callback } }) {
  const payload = {
    params: data,
    method: "get",
    url: "outreach/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    callback(
      error
        ? { success: false, data: null }
        : { success: true, data: result.data }
    );
  }
}

function* outreachDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `outreach/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    callback(
      error
        ? { success: false, data: null }
        : { success: true, data: result.data }
    );
  }
}

function* addOutreach({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "outreach",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* updateOutreach({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `outreach/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    callback(
      error
        ? { success: false, data: null }
        : { success: true, data: result.data }
    );
  }
}

function* deleteOutreach({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `outreach/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (error) {
      callback({ success: false, data: null });
    } else {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Outreach() {
  yield all([
    takeLatest(OUTREACH_LIST, getOutreachList),
    takeLatest(OUTREACH_DETAILS, outreachDetails),
    takeLatest(ADD_OUTREACH, addOutreach),
    takeLatest(UPDATE_OUTREACH, updateOutreach),
    takeLatest(DELETE_OUTREACH, deleteOutreach),
  ]);
}

export default Outreach;
